import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index' //主页
import Indexm from '@/views/indexm' //  M主页
import Contactus from '@/views/contactus/contactus' //联系我们
import Czcy from '@/views/Proservices/czcy' //产品服务-车镇车源
import Cly from '@/views/Proservices/cly' //产品服务-车链云
import Mgd from '@/views/Proservices/mgd' //产品服务-秒个贷
import Czwl from '@/views/Proservices/czwl' //产品服务-车镇物流
import Cycj from '@/views/Proservices/cycj' //产品服务-车源采集
import Zhcc from '@/views/Proservices/zhcc' //产品服务-智慧车城
import Aboutus from '@/views/aboutus/aboutus' //关于我们
import Aboutusm from '@/views/aboutus/aboutusm' //关于我们 M端
import Cartownnews from '@/views/Cartownnews/Cartownnews' //车镇动态
import Czarticle from '@/views/Cartownnews/Czarticle' //车镇文章
import Gamefoto from '@/views/alldetails/Gamefoto' //员工活动集锦&历届私董会
import Album from '@/views/alldetails/album' //相册

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Index',
      component: Index
    }, {
      path: '/Indexm',
      name: 'Indexm',
      component: Indexm
    }, {
      path: '/contactus',
      name: 'Contactus',
      component: Contactus,
      meta: {
        title: "联系我们"
      }
    }, {
      path: '/Czcy',
      name: 'Czcy',
      component: Czcy,
      meta: {
        title: "产品服务-车镇车源"
      }
    }, , {
      path: '/Cly',
      name: 'Cly',
      component: Cly,
      meta: {
        title: "产品服务-车链云"
      }
    }, , {
      path: '/Mgd',
      name: 'Mgd',
      component: Mgd,
      meta: {
        title: "产品服务-秒个贷"
      }
    }, , {
      path: '/Czwl',
      name: 'Czwl',
      component: Czwl,
      meta: {
        title: "产品服务-车镇物流"
      }
    },
    {
      path: '/Cycj',
      name: 'Cycj',
      component: Cycj,
      meta: {
        title: "产品服务-车源采集"
      }
    },
    {
      path: '/Zhcc',
      name: 'Zhcc',
      component: Zhcc,
      meta: {
        title: "产品服务-智慧车城"
      }
    },
    {
      path: '/Aboutus',
      name: 'Aboutus',
      component: Aboutus,
      meta: {
        title: "关于我们",
        keepAlive: true
      }
    },
    {
      path: '/Aboutusm',
      name: 'Aboutusm',
      component: Aboutusm,
      meta: {
        title: "关于我们",
        keepAlive: true
      }
    },
    {
      path: '/Cartownnews',
      name: 'Cartownnews',
      component: Cartownnews,
      meta: {
        title: "车镇动态"
      }
    },
    {
      path: '/Czarticle',
      name: 'Czarticle',
      component: Czarticle,
      meta: {
        title: ""
      }
    },
    {
      path: '/Gamefoto',
      name: 'Gamefoto',
      component: Gamefoto
    },
    {
      path: '/Album',
      name: 'Album',
      component: Album,
      meta: {
        title: "相册"
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js